import { useEffect, useState } from "react";
import { authContext } from "./AuthContext";
import { UserType } from "../Types/UsersType";
import { Api } from "../Services/CohortServices";

export const AuthProvider = ({ children }: { children: JSX.Element }) => {
  const [user, setUser] = useState<UserType | null>(null);
  const [loading, setLoading] = useState<boolean>(true);

  useEffect(() => {
    const controller = new AbortController();
    const validation = async () => {
      const storageData = localStorage.getItem('user');
      if (storageData) {
        try {
          let userStorage = JSON.parse(storageData);
          const response = await Api.get(`/users/${userStorage.id}`);

          if (response) {
            setUser(response.data);
          } else {
            console.error('Erro: Resposta inesperada da API');
          }
        } catch (error) {
          console.error("Erro de autenticação");
        }
      }
      setLoading(false); // Indicar que a validação terminou
    };

    validation();

    return () => {
      controller.abort();
    };
  }, []);

  const signIn = async (email: string, password: string) => {
    try {
      const { data } = await Api.post('/login', { email, password });

      if (data) {
        setUser(data);
        localStorage.setItem('user', JSON.stringify(data));
      } else {
        console.error('Erro: Resposta inesperada da API');
      }
      return true;
    } catch (Error) {
      const ErrorType = (Error as any).response.data;
      if (ErrorType.Error === "Wrong Password!") {
        alert('Senha incorreta!');
        return false;
      }

      alert('Usuario: não encontrado!');
      return false;
    }
  };

  const signOut = () => {
    setUser(null);
    localStorage.removeItem('user');
  };

  return (
    <authContext.Provider value={{ user, signIn, signOut, loading }}>
      {children}
    </authContext.Provider>
  );
};
